var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMasterCardLogo = function SvgMasterCardLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.625H12V20.625H20V4.625Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2337 12.625C12.2337 9.43056 13.7182 6.59723 16 4.76389C14.323 3.43056 12.2062 2.625 9.89691 2.625C4.42612 2.625 0 7.09722 0 12.625C0 18.1528 4.42612 22.625 9.89691 22.625C12.2062 22.625 14.323 21.8195 16 20.4861C13.7182 18.6806 12.2337 15.8194 12.2337 12.625Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 12.625C32 18.1528 27.5739 22.625 22.1031 22.625C19.7938 22.625 17.677 21.8195 16 20.4861C18.3093 18.6528 19.7663 15.8194 19.7663 12.625C19.7663 9.43056 18.2818 6.59723 16 4.76389C17.677 3.43056 19.7938 2.625 22.1031 2.625C27.5739 2.625 32 7.125 32 12.625Z",
    fill: "#F79E1B"
  })));
};
export default SvgMasterCardLogo;